import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./Css/AddQuestion.css";
import API_BASE from "../config/api";

const AddQuestion = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [subject, setSubject] = useState("");
  const [chapter, setChapter] = useState("");
  const [topic, setTopic] = useState("");
  const [subtopic, setSubtopic] = useState("");
  const [tab, setTab] = useState("paragraph");
  const [paperInfo, setPaperInfo] = useState(null);
  const [selectedList, setSelectedList] = useState([]);

  const [selectedBySubject, setSelectedBySubject] = useState({
    Marathi: { "Chapter 1": [], "Chapter 2": [] },
    English: { "Chapter 1": [], "Chapter 2": [] },
  });


  const [dropdowns, setDropdowns] = useState({
    subjects: [],
    topics: [],
    subtopics: []
  });

  const loadDropdowns = async (subId, topicVal) => {
    const res = await axios.get(
      `${API_BASE}/api/Papers/teacher-manual-question-dropdowns?paperId=${id}&subjectId=${subId || ""}&topic=${topicVal || ""}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );
    setDropdowns(res.data);
  };

  const loadQuestions = async (filters = {}) => {
    const res = await axios.post(
      `${API_BASE}/api/Papers/available-questions/${id}`,
      filters,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );
    console.log(res.data)
    setPaperInfo(res.data.paper);
    setAvailableQuestions(res.data.regularQuestions);
    setParagraphQuestions(res.data.paragraphs);
  };

  useEffect(() => {
    loadDropdowns();
    loadQuestions({});
  }, []);

  const allSelected = selectedList;

  const totalSelected = allSelected.length;

  const totalMarks = useMemo(
    () => allSelected.reduce((sum, q) => sum + (q.mark || 0), 0),
    [allSelected]
  );

  const selectedInThisSubject =
    selectedList.filter(q => q.subject == subject);
  const selectedCountThisSubject = selectedInThisSubject.length;
  const selectedInThisChapter =
    selectedList.filter(q => q.chapter == chapter && q.subject == subject);
  const selectedCountThisChapter = selectedInThisChapter.length;

  const SUBJECT_LIMIT = 5;
  const GLOBAL_LIMIT = 40;
  const isSubjectLimitReached =
    subject && selectedCountThisSubject >= SUBJECT_LIMIT;
  const isGlobalLimitReached = totalSelected >= GLOBAL_LIMIT;

  const [availableQuestions, setAvailableQuestions] = useState([]);
  const [allRegularQuestions, setAllRegularQuestions] = useState([]);
  const [paragraphQuestions, setParagraphQuestions] = useState([]);

  const isGloballySelected = (id) =>
    allSelected.some((it) => it.questionId === id);

  // const totalMarks = paperInfo.marks;

  const handleAddQuestion = async (question) => {
    if (isGloballySelected(question.id)) return;
    if (totalMarks + question.mark > paperInfo?.marks) return;

    try {
      await axios.post(
        `${API_BASE}/api/Papers/${id}/add-questions`,
        { questionIds: [question.id] },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` } }
      );

      setSelectedList(prev => [
        ...prev,
        {
          id: question.id,
          text: question.questionText,
          questionId: question.id,
          type: "regular",
          chapter,
          subject,
          mark: question.mark
        }
      ]);

    } catch (err) {
      alert("Failed to add question");
    }
  };

  const handleAddParagraph = async (para) => {
    try {
      await axios.post(
        `${API_BASE}/api/Papers/${id}/add-questions`,
        { paragraphId: para.paragraphId },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` } }
      );

      // ✅ add questions to selected state
      setSelectedList(prev => [
        ...prev,
        ...para.questions.map(q => ({
          id: `para-${q.id}`,
          text: q.questionText,
          questionId: q.id,
          type: "paragraph",
          chapter,
          subject,
          mark: q.mark
        }))
      ]);

    } catch {
      alert("Failed to add paragraph");
    }
  };


  const handleRemoveQuestion = async (index) => {
    const item = allSelected[index];
    if (!item) return;

    try {
      await axios.delete(
        `${API_BASE}/api/Papers/${id}/questions/${item.questionId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        }
      );

      // only update state AFTER backend success
      setSelectedList(prev =>
        prev.filter((_, i) => i !== index)
      );

    } catch (err) {
      alert("Failed to remove question from paper");
    }
  };

  const handlePreviewClick = () => {
    navigate(`/dashboard/previewpaper/${id}`);
  };

  return (
    <div className="builder-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt;परीक्षा तयार करा &gt;&gt; <span>प्रश्न जोडा </span>
        </h3>

        <div className="edit-btnn">
          <button
            className="builder-container-preview-btn"
            onClick={handlePreviewClick}
            disabled={totalSelected === 0}
          >
            प्रिव्ह्यू
          </button>
        </div>
      </div>
      <div className="builder-container-header">
        <p>
          <strong>परीक्षेचे नाव:</strong> {paperInfo?.softwareName} &nbsp;
          <strong>इयत्ता:</strong> {paperInfo?.standardName} &nbsp;&nbsp;
          <strong>एकूण गुण :</strong> {paperInfo?.marks} Marks
        </p>
      </div>

      <div className="crt-exam">
        <div>
          <select
            className="chapter-select"
            value={subject}
            onChange={async e => {
              const val = e.target.value;
              setSubject(val);
              setTopic("");
              setSubtopic("");

              await loadDropdowns(val, null);
              await loadQuestions({ subjectId: Number(val) });
            }}
          >
            <option value="">विषय</option>
            {dropdowns.subjects.map(x => (
              <option key={x.id} value={x.id}>{x.name}</option>
            ))}
          </select>
        </div>

        <select
          className="chapter-select"
          value={topic}
          onChange={async e => {
            const val = e.target.value;
            setTopic(val);
            setSubtopic("");

            await loadDropdowns(subject, val);
            await loadQuestions({
              subjectId: Number(subject),
              topic: val
            });
          }}
          disabled={isSubjectLimitReached}
        >
          <option value="">घटक</option>
          {dropdowns.topics.map(x => (
            <option key={x.name} value={x.name}>{x.name}</option>
          ))}

        </select>

        <select
          className="chapter-select"
          value={subtopic}
          onChange={async e => {
            const val = e.target.value;
            setSubtopic(val);

            await loadQuestions({
              subjectId: Number(subject),
              topic,
              subtopic: val
            });
          }}
          disabled={isSubjectLimitReached}
        >
          <option value="">उपघटक</option>
          {dropdowns.subtopics.map(x => (
            <option key={x.name} value={x.name}>{x.name}</option>
          ))}
        </select>
      </div>

      <div className="tabs">
        <button
          className={tab === "paragraph" ? "active-tab" : ""}
          onClick={() => setTab("paragraph")}
        >
          परिच्छेद प्रश्न
        </button>
        <button
          className={tab === "regular" ? "active-tab" : ""}
          onClick={() => setTab("regular")}
        // disabled={totalMarks + q.mark > paperInfo?.marks}
        >
          रेग्युलर प्रश्न
        </button>
      </div>

      <div className="main-contentt">
        {tab === "paragraph" && (
          <div className="paragraph-questions">
            <h3 className="que-head">Paragraphs</h3>
            {paragraphQuestions.length === 0 ? (
              <p className="empty-msg">
                {isSubjectLimitReached
                  ? "Subject limit reached"
                  : "Please select a chapter to view paragraph questions."}
              </p>
            ) : (
              paragraphQuestions.map((para, idx) => {
                const paraQuestionsAvailable = para.questions.filter(
                  q => !isGloballySelected(q.id)
                ).length;

                return (
                  <div key={`${subject}|${chapter}|para|${idx}`} className="paragraph-box">
                    <div className="para-svg-sep">
                      <h4>{para.title}</h4>
                      <svg xmlns="http://www.w3.org/2000/svg" className="para-svg" width="20" height="14" viewBox="0 0 22 16" fill="none">
                        <path d="M11 12.5C12.25 12.5 13.3125 12.0625 14.1875 11.1875C15.0625 10.3125 15.5 9.25 15.5 8C15.5 6.75 15.0625 5.6875 14.1875 4.8125C13.3125 3.9375 12.25 3.5 11 3.5C9.75 3.5 8.6875 3.9375 7.8125 4.8125C6.9375 5.6875 6.5 6.75 6.5 8C6.5 9.25 6.9375 10.3125 7.8125 11.1875C8.6875 12.0625 9.75 12.5 11 12.5ZM11 10.7C10.25 10.7 9.6125 10.4375 9.0875 9.9125C8.5625 9.3875 8.3 8.75 8.3 8C8.3 7.25 8.5625 6.6125 9.0875 6.0875C9.6125 5.5625 10.25 5.3 11 5.3C11.75 5.3 12.3875 5.5625 12.9125 6.0875C13.4375 6.6125 13.7 7.25 13.7 8C13.7 8.75 13.4375 9.3875 12.9125 9.9125C12.3875 10.4375 11.75 10.7 11 10.7ZM11 15.5C8.56667 15.5 6.35 14.8208 4.35 13.4625C2.35 12.1042 0.9 10.2833 0 8C0.9 5.71667 2.35 3.89583 4.35 2.5375C6.35 1.17917 8.56667 0.5 11 0.5C13.4333 0.5 15.65 1.17917 17.65 2.5375C19.65 3.89583 21.1 5.71667 22 8C21.1 10.2833 19.65 12.1042 17.65 13.4625C15.65 14.8208 13.4333 15.5 11 15.5ZM11 13.5C12.8833 13.5 14.6125 13.0042 16.1875 12.0125C17.7625 11.0208 18.9667 9.68333 19.8 8C18.9667 6.31667 17.7625 4.97917 16.1875 3.9875C14.6125 2.99583 12.8833 2.5 11 2.5C9.11667 2.5 7.3875 2.99583 5.8125 3.9875C4.2375 4.97917 3.03333 6.31667 2.2 8C3.03333 9.68333 4.2375 11.0208 5.8125 12.0125C7.3875 13.0042 9.11667 13.5 11 13.5Z" fill="black" />
                      </svg>
                    </div>
                    <ol className="mul-para">
                      {para.questions.slice(0, 3).map((q, i) => (
                        <li
                          className={`mul-que ${isGloballySelected(q.id) ? "selected-question" : ""}`}
                          key={`${subject}|${chapter}|para|${idx}|q|${i}`}
                        >
                          {q.questionText}
                          {isGloballySelected(q.id) && (
                            <span className="selected-tag">(Selected)</span>
                          )}
                        </li>
                      ))}
                    </ol>
                    <button
                      onClick={() => handleAddParagraph(para)}
                      disabled={isSubjectLimitReached || paraQuestionsAvailable === 0}
                      title={
                        isSubjectLimitReached
                          ? `Subject limit reached (${SUBJECT_LIMIT})`
                          : paraQuestionsAvailable === 0
                            ? "All questions already selected"
                            : ""
                      }
                    >
                      Add Paragraph (+{paraQuestionsAvailable} Questions)
                    </button>
                  </div>
                );
              })
            )}
          </div>
        )}

        {tab === "regular" && (
          <div className="questions-panel">
            <h3 className="que-head">Regular</h3>
            {availableQuestions.length === 0 ? (
              <p className="empty-msg">
                {isSubjectLimitReached
                  ? "Subject limit reached"
                  : "No available questions or all questions already selected"}
              </p>
            ) : (
              availableQuestions.map((q, index) => {
                const globallySelected = isGloballySelected(q.id);
                const disabled = isSubjectLimitReached || globallySelected;
                const markExceeded = totalMarks + q.mark > paperInfo?.marks;
                const title = isSubjectLimitReached
                  ? `Subject limit reached (${SUBJECT_LIMIT})`
                  : globallySelected
                    ? "Already added from another chapter/subject"
                    : "";
                return (
                  <button
                    key={q.id}
                    className={`question-button ${globallySelected ? "selected-question" : ""}`}
                    onClick={() => handleAddQuestion(q)}
                    disabled={globallySelected || markExceeded}
                    title={
                      markExceeded
                        ? "Marks limit reached"
                        : globallySelected
                          ? "Already selected"
                          : ""
                    }
                  >
                    {q.questionText}
                    {globallySelected && (
                      <span className="selected-tag">(Selected)</span>
                    )}
                  </button>
                );
              })
            )}
          </div>
        )}

        <div className="selected-panel">
          <div className="selected-title">
            <span>गुण - {totalMarks}/{paperInfo?.marks}</span>
          </div>
          <div className="selected-list">
            {totalSelected === 0 && (
              <div className="drop-placeholder">Drop Here</div>
            )}
            {allSelected.map((item, index) => (
              <div key={item.id} className="selected-item">
                <div className="que-add-span">
                  <span className="que-span">{item.text}</span>
                </div>
                <div className="que-remove">
                  <span className="marks-span">{item.mark}</span>
                  <button
                    className="selected-list-remove-btn"
                    onClick={() => handleRemoveQuestion(index)}
                  >
                    -
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isSubjectLimitReached && (
        <p className="limit-warning">
          Note: {subject} Subject Reached Their Limit
          {totalSelected < GLOBAL_LIMIT ? " Please Select Another Subject." : ""}
        </p>
      )}

      {isGlobalLimitReached && (
        <p className="limit-warning">
          Note: Total questions limit reached ({GLOBAL_LIMIT} questions).
        </p>
      )}


    </div>
  );
};

export default AddQuestion;